import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import CircularLoader from "../CircularLoader";
import {
  Box,
  Typography,
  Avatar,
  InputLabel,
  TextField,
  DialogTitle,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  protocol,
  hostname,
  domain,
  connectionsApiUrl,
} from "../../utils/config";
import DynamicFont from "react-dynamic-font";
import { ReactComponent as CloseIcon } from "../../assests/icons/close_icon_transparent.svg";
import { ReactComponent as CloseIconRed } from "../../assests/icons/close_icon_red.svg";
import { ReactComponent as Addressicon } from "../../assests/icons/icon_address.svg";
import { ReactComponent as PhoneIcon } from "../../assests/icons/icon_phone_number.svg";
import { useGetRequests, usePostRequests } from "../../utils/queries";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import { ConnectionsToken, homeToken } from "../../utils/constant";
import {
  AddressBox,
  AddressText,
  AvtarCardBox,
  AvtarCardBoxWrap,
  ButtonBoxWrap,
  CloseIconBoxWrapLeft,
  CloseIconBoxWrapRight,
  DetailBoxWrap,
  DialogBoxWrap,
  ProfessionNameText,
  InputDialogBoxWrap,
  InputLabelBoxSmall,
  InputLabelBoxBig,
} from "./Dialog.styles";

const SearchConnectionDialogButton = ({
  btntype = "",
  value,
  onClickHandler = () => {},
}) => {
  return (
    <Button
      onClick={onClickHandler}
      sx={{
        width: "13rem",
        padding: "0.5rem 0.5rem",
        border: btntype === "grey" ? "2px solid #676767" : "2px solid #cf2030",
        color:
          btntype === "outlined"
            ? "#cf2030"
            : btntype === "grey"
            ? "#676767"
            : "#ffffff",
        background:
          btntype === "outlined"
            ? "#cf2030"
            : btntype === "grey"
            ? "#FFFFFF"
            : "#cf2030",
        "&:hover": {
          background:
            btntype === "outlined"
              ? "#ffffff"
              : btntype === "grey"
              ? "#FFFFFF"
              : "#cf2030",
        },
      }}
    >
      <Box sx={{ maxWidth: "100%", textAlign: "center" }}>
        <DynamicFont content={value} />
      </Box>
    </Button>
  );
};

const ViewSearchConnectionDetilDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [isHover, setIsHover] = useState(false);
  const [connectionForm, setConnectionForm] = useState(true);
  const theme = useTheme();
  const userData = useSelector((state) => state.dialog.dataObj);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultMessage, setDefaultMessage] = useState("");
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const getConnectionRequestTemplate = useGetRequests();

  const sendConnectionRequests = usePostRequests();

  const {
    profileImage,
    name,
    profession,
    secondaryCategory,
    chapterName,
    connectionUser,
    address,
    phoneNumber,
  } = userData;

  const handleSubmitConnectionRequest = () => {
    if (defaultMessage.trim()) {
      setOpen(false);
      setIsLoading(true);
      sendConnectionRequests.mutate(
        {
          url: `${domain}social-api/connections/`,
          data: {
            userId: connectionUser,
            connectionReqBody: defaultMessage.trim(),
          },
        },
        {
          mutationKey: "sendConnectionRequest",
          onSuccess: (success) => {
            if (success.status === 200) {
              setIsLoading(false);
              setOpen(false);
              dispatch(dialogActions.setDialogType("connectionsuccess"));
              // setTimeout(() => {
              //   dispatch(dialogActions.setDialogType(""));
              // }, 2000);
            }
          },
          onError: (error) => {
            console.log(" request rejectOrIgnoreRequest failed ", error);
            setIsLoading(false);
            alert(t(homeToken.GenericError));
          },
        }
      );
    } else {
      setErrorMsg(true);
      setDefaultMessage("");
    }
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
  };

  const handleViewProfile = () => {
    window.location.href = `/web/secure/networkHome?userId=${connectionUser}`;
    return;
  };

  const handleConnectionForm = () => {
    setConnectionForm(!connectionForm);
    getConnectionRequestTemplate.mutate(
      {
        url: `${connectionsApiUrl}${connectionUser}/request-template`,
      },
      {
        mutationKey: "getConnectionRequestTemplate",
        onSuccess: (success) => {
          if (success.status === 200) {
            setDefaultMessage(success.data.content.responseBody);
          }
        },
        onError: (error) => {
          console.log(" api call error data is ", error);
          alert(t(homeToken.GenericError));
        },
        cacheTime: 0,
      }
    );
    // return;
  };

  const handleCancel = () => {
    setConnectionForm(!connectionForm);
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        {connectionForm ? (
          <>
            <DialogBoxWrap>
              <AvtarCardBoxWrap>
                <AvtarCardBox>
                  <Box
                    sx={{
                      width: "7.8rem",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Avatar
                      alt={`${name} profile image`}
                      src={
                        profileImage
                          ? `${protocol}${hostname}:443//core-api/public/image/${profileImage}`
                          : `${name}`
                      }
                      sx={{ width: "10.4rem", height: "10.4rem" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      justifyContent: "space-between",
                      rowGap: "1rem",
                    }}
                  >
                    <Typography
                      title={name ? `${name}` : " "}
                      sx={{
                        fontSize: "2rem",
                        color: "#cf2030",
                        width: "13rem",
                        textWrap: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        cursor: "default",
                        lineHeight: "normal",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {name ? `${name}` : ""`${name}`}
                    </Typography>
                    <SearchConnectionDialogButton
                      value={"View Profile"}
                      onClickHandler={handleViewProfile}
                      btntype="grey"
                    />
                  </Box>
                </AvtarCardBox>
                <CloseIconBoxWrapLeft>
                  <CloseIcon
                    fill={isHover ? "#cf2030" : "#64666A"}
                    onClick={handleClose}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                  />
                </CloseIconBoxWrapLeft>
              </AvtarCardBoxWrap>
              <DetailBoxWrap>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <ProfessionNameText
                      title={`${profession ? t(profession) : " "} | ${
                        secondaryCategory ? t(secondaryCategory) : " "
                      }`}
                    >
                      {profession && secondaryCategory
                        ? `${t(profession)} | ${t(secondaryCategory)}`
                        : profession
                        ? t(profession)
                        : secondaryCategory
                        ? t(secondaryCategory)
                        : "\u00A0"}
                    </ProfessionNameText>
                    <Box
                      sx={{
                        fontSize: "1.8rem",
                        color: "#cf2030",
                        cursor: "default",
                        lineHeight: "normal",
                      }}
                    >
                      {`${chapterName ? chapterName : "\u00A0"}`}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "2rem",
                    }}
                  >
                    <AddressBox>
                      <Box>
                        <Addressicon />
                      </Box>
                      <AddressText title={address}>{address}</AddressText>
                    </AddressBox>
                    <Box sx={{ display: "flex", columnGap: "2rem" }}>
                      <Box>
                        <PhoneIcon />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "1.2rem",
                          color: "#676767",
                          textAlign: "left",
                          cursor: "default",
                          textWrap: "wrap",
                        }}
                      >
                        {phoneNumber}
                      </Typography>
                    </Box>
                  </Box>
                  <ButtonBoxWrap>
                    <SearchConnectionDialogButton
                      value="connect"
                      onClickHandler={handleConnectionForm}
                      btntype="outline"
                    />
                  </ButtonBoxWrap>
                </Box>
                <CloseIconBoxWrapRight>
                  <CloseIcon
                    fill={isHover ? "#cf2030" : "#64666A"}
                    onClick={handleClose}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                  />
                </CloseIconBoxWrapRight>
              </DetailBoxWrap>
            </DialogBoxWrap>
          </>
        ) : getConnectionRequestTemplate.isLoading ? (
          <>
            <Box
              sx={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                padding: "2rem",
                width: "74.5rem",
                height: "31rem",
                columnGap: "2rem",
                overflow: "hidden",
                borderRadius: "1rem",
              }}
            >
              <Box sx={{ position: "relative" }}>
                <CircularProgress
                  variant="determinate"
                  sx={{
                    color: (theme) =>
                      theme.palette.grey[
                        theme.palette.mode === "light" ? 300 : 700
                      ],
                  }}
                  size={40}
                  thickness={4}
                  value={100}
                />
                <CircularProgress
                  variant="indeterminate"
                  disableShrink
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "light" ? "#cf2030" : "#308fe8",
                    animationDuration: "550ms",
                    position: "absolute",
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                      strokeLinecap: "round",
                    },
                  }}
                  size={40}
                  thickness={4}
                />
              </Box>
            </Box>
          </>
        ) : (
          <>
            <InputDialogBoxWrap>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingBottom: "0.2rem",
                  borderBottom: "1px solid #c8c8c8",
                }}
              >
                <DialogTitle
                  id="responsive-dialog-title"
                  sx={{
                    margin: "auto",
                    padding: "0",
                    fontSize: "2.5rem",
                    color: "#cf2030",
                  }}
                >
                  {t(ConnectionsToken.AddToMyConnections)}
                </DialogTitle>
                <CloseIconRed onClick={handleClose} />
              </Box>
              <Box sx={{ width: "100%" }}>
                <DialogContent>
                  <InputLabelBoxSmall>
                    <InputLabel>
                      {dialogType === "givetestimonial"
                        ? t(ConnectionsToken.Testimonial)
                        : t(homeToken.Message)}
                      <Box sx={{ color: "#cf2030" }} component={"span"}>
                        {" "}
                        *
                      </Box>
                    </InputLabel>
                  </InputLabelBoxSmall>
                  <InputLabel
                    sx={{
                      textAlign: "right",
                      p: 1,
                      color: "#CF2030",
                      visibility: errorMsg ? "visible" : "hidden",
                    }}
                  >
                    * {t(homeToken.RequiredFields)}
                  </InputLabel>
                  <Box sx={{ display: "flex", columnGap: "2rem" }}>
                    <InputLabelBoxBig>
                      <InputLabel>
                        {dialogType === "givetestimonial"
                          ? t(ConnectionsToken.Testimonial)
                          : t(homeToken.Message)}
                        <Box sx={{ color: "#cf2030" }} component={"span"}>
                          {" "}
                          *
                        </Box>
                      </InputLabel>
                    </InputLabelBoxBig>
                    <Box
                      sx={{
                        flex: "82%",
                        height: "13.5rem",
                        overflow: "hidden",
                        alignItems: "right",
                        padding: "0rem 1rem 0rem 1rem",
                      }}
                      data-color-mode="light"
                    >
                      <TextField
                        multiline
                        fullWidth
                        maxRows={5}
                        minRows={5}
                        variant="standard"
                        value={defaultMessage}
                        onChange={(e) => {
                          setDefaultMessage(e.target.value);
                          setErrorMsg(false);
                        }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                        sx={{
                          backgroundColor: "#F2F2F2",
                          padding: "10px",
                          borderRadius: ".5rem",
                          height: "13.4rem",
                          fontSize: "1.4rem",
                          border: errorMsg ? "2px solid #CF2030" : "",
                          outline: 0,
                          overflow: "scroll",
                          ".MuiInputBase-input": {
                            color: "#64666A",
                            scrollbarWidth: "auto",
                          },
                          ".MuiInputBase-input::-webkit-scrollbar": {
                            width: "0.7rem",
                            right: "0.5rem",
                          },
                        }}
                        placeholder={t(homeToken.EnterMessage)}
                      />
                    </Box>
                  </Box>
                </DialogContent>
              </Box>
              <DialogActions
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  gap: ".5rem",
                }}
              >
                <Button
                  onClick={handleSubmitConnectionRequest}
                  sx={{
                    padding: "0.5rem 2rem",
                    border: "2px solid #cf2030",
                    color: "#FFFFFF",
                    backgroundColor: "#cf2030",
                    "&:hover": { background: "#cf2030", color: "#f2f2f2" },
                  }}
                >
                  Submit
                </Button>
                <Button
                  onClick={handleCancel}
                  sx={{
                    padding: "0.5rem 2rem",
                    border: "2px solid #cf2030",
                    color: "#cf2030",
                    "&:hover": { background: "#cf2030", color: "#f2f2f2" },
                  }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </InputDialogBoxWrap>
          </>
        )}
      </Dialog>
      {isLoading && <CircularLoader />}
    </Box>
  );
};

export default ViewSearchConnectionDetilDialog;
